import { IconPropsBase } from './IconPropsBase';

export default function OpenInPhoneIcon({ size = 20, color = 'currentColor' }: IconPropsBase) {
  if (size > 20) {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 -960 960 960">
        <path
          fill={color}
          d="M292.31-60Q262-60 241-81q-21-21-21-51.31V-360h60v130h400v-500H280v130h-60v-227.69Q220-858 241-879q21-21 51.31-21h375.38Q698-900 719-879q21 21 21 51.31v695.38Q740-102 719-81q-21 21-51.31 21H292.31ZM280-170v37.69q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h375.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-170H280Zm120-163.85L357.85-376l72.77-74H90v-60h340.62l-72.77-74L400-626.15 546.15-480 400-333.85ZM280-790h400v-37.69q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H292.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46V-790Zm0 0v-50 50Zm0 620v50-50Z"
        />
      </svg>
    );
  } else {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 -960 960 960">
        <path
          fill={color}
          d="M276.31-68q-27.01 0-45.66-18.65Q212-105.3 212-132.31V-336h52v106h432v-500H264v106h-52v-203.96q0-27.04 18.65-45.54t45.66-18.5h407.38q27.01 0 45.66 18.65Q748-854.7 748-827.69v695.38q0 27.01-18.65 45.66Q710.7-68 683.69-68H276.31ZM264-178v45.69q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h407.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-178H264Zm168-123.85L394.85-339l115.77-115H106v-52h404.62L394.85-621 432-658.15 610.15-480 432-301.85ZM264-782h432v-45.69q0-4.62-3.85-8.46-3.84-3.85-8.46-3.85H276.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46V-782Zm0 0v-58 58Zm0 604v58-58Z"
        />
      </svg>
    );
  }
}
